import { createContext } from 'react';

interface HoverContextType {
    hoveredProductIdState: string;
    setHoveredProductId: (productId: string) => void;
}

export const HoverContext = createContext<HoverContextType>({} as HoverContextType);
